import { RightsEnum } from '../enums/rights.enum';
import { ScreensEnum } from '../enums/screens.enum';

const AclPathPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    //Roles
    'roles': { screen: ScreensEnum.Role, right: RightsEnum.View },
    'editrole': { screen: ScreensEnum.Role, right: RightsEnum.Update },
    'addrole': { screen: ScreensEnum.Role, right: RightsEnum.Create },

    //Users
    'users': { screen: ScreensEnum.User, right: RightsEnum.View },
    'edituser': { screen: ScreensEnum.User, right: RightsEnum.Update },
    'adduser': { screen: ScreensEnum.User, right: RightsEnum.Create },

    //Screens
    'screens': { screen: ScreensEnum.Screen, right: RightsEnum.View },
    'editscreen': { screen: ScreensEnum.Screen, right: RightsEnum.Update },

    //Screen Right
    'screenrightgroups': { screen: ScreensEnum.ScreenRightGroup, right: RightsEnum.View },
    'editscreenrightgroup': { screen: ScreensEnum.ScreenRightGroup, right: RightsEnum.Update },
    'addscreenrightgroup': { screen: ScreensEnum.ScreenRightGroup, right: RightsEnum.Create },

    //Role to Screen
    'roletoscreens': { screen: ScreensEnum.RoleToScreen, right: RightsEnum.View },
    'editroletoscreen': { screen: ScreensEnum.RoleToScreen, right: RightsEnum.Update },
    'addroletoscreen': { screen: ScreensEnum.RoleToScreen, right: RightsEnum.Create },
};

const ModelPathPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    //Models
    'models': { screen: ScreensEnum.Algorithm, right: RightsEnum.View },
    'addmodel': { screen: ScreensEnum.Algorithm, right: RightsEnum.Create },
    'editmodel': { screen: ScreensEnum.Algorithm, right: RightsEnum.Update },

    //PdM Code Mapping
    'addpdmmapping': { screen: ScreensEnum.Algorithm, right: RightsEnum.Create },
    'editpdmmapping': { screen: ScreensEnum.Algorithm, right: RightsEnum.Update },

    //Suppression Rule Mapping
    'addsuppressionrule': { screen: ScreensEnum.Algorithm, right: RightsEnum.Create },
    'editsuppressionrule': { screen: ScreensEnum.Algorithm, right: RightsEnum.Update },

    'jobinfo': { screen: ScreensEnum.Algorithm, right: RightsEnum.View },
};

const ProductPathPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    //Product Family
    'families': { screen: ScreensEnum.ProductFamily, right: RightsEnum.View },
    'editproductfamily': { screen: ScreensEnum.ProductFamily, right: RightsEnum.Update },
    'addproductfamily': { screen: ScreensEnum.ProductFamily, right: RightsEnum.Create },

    //Product Line
    'lines': { screen: ScreensEnum.ProductLine, right: RightsEnum.View },
    'editproductline': { screen: ScreensEnum.ProductLine, right: RightsEnum.Update },
    'addproductline': { screen: ScreensEnum.ProductLine, right: RightsEnum.Create }
};

const RulesPathPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    //Notification Rule
    'notificationrules': { screen: ScreensEnum.NotificationRules, right: RightsEnum.View },
    'addnotificationrule': { screen: ScreensEnum.NotificationRules, right: RightsEnum.Create },
    'editnotificationrule': { screen: ScreensEnum.NotificationRules, right: RightsEnum.Update },

    //Ticketing Rule
    //'ticketingrules': { screen: ScreensEnum.TicketingRules, right: RightsEnum.View }
};

//Need / because home is our base route
const HomePermission: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    '/home': { screen: ScreensEnum.Home, right: RightsEnum.View}
};

const MasterDataPermission: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    'masterdata': { screen: ScreensEnum.MasterData, right: RightsEnum.View},
    'addmasterdata': { screen: ScreensEnum.MasterData, right: RightsEnum.Create},
    'editmasterdata': { screen: ScreensEnum.MasterData, right: RightsEnum.Update}
};

const SystemPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    //Service Contract
    'servicecontracts': { screen: ScreensEnum.ServiceContract, right: RightsEnum.View },
    'editservicecontract': { screen: ScreensEnum.ServiceContract, right: RightsEnum.Update },
    'addservicecontract': { screen: ScreensEnum.ServiceContract, right: RightsEnum.Create },

    //Exclusions
    'exclusions': { screen: ScreensEnum.Exclusions, right: RightsEnum.View },
    'editexclusions': { screen: ScreensEnum.Exclusions, right: RightsEnum.Update },
    'addexclusions': { screen: ScreensEnum.Exclusions, right: RightsEnum.Create },

    'notificationtemplates': { screen: ScreensEnum.NotificationTemplate, right: RightsEnum.View },
    'addnotificationtemplate': { screen: ScreensEnum.NotificationTemplate, right: RightsEnum.Create },
    'editnotificationtemplate': { screen: ScreensEnum.NotificationTemplate, right: RightsEnum.Update },

    'notificationtemplatelocales': { screen: ScreensEnum.TemplateLocale, right: RightsEnum.View },
    'addnotificationtemplatelocale': { screen: ScreensEnum.TemplateLocale, right: RightsEnum.Create },
    'editnotificationtemplatelocale': { screen: ScreensEnum.TemplateLocale, right: RightsEnum.Update },
};

export const AppPathPermissions: { [id: string]: { screen: ScreensEnum, right: RightsEnum } } = {
    ...AclPathPermissions,
    ...ModelPathPermissions,
    ...ProductPathPermissions,
    ...RulesPathPermissions,
    ...HomePermission,
    ...SystemPermissions,
    ...MasterDataPermission
};

